export const flarelaneEventKeys = {
  pvm_pdp_inquiry_button_click: 'pvm_pdp_inquiry_button_click',
  pvm_sell_tractor_complete: 'pvm_sell_tractor_complete',
  pvm_sell_tractor_complete_with_new_machine: 'pvm_sell_tractor_complete_with_new_machine',
  pvm_sell_tractor_incomplete: 'pvm_sell_tractor_incomplete',
  pvm_fail_bump: 'pvm_fail_bump',
  pvm_inquiry_pluva_product: 'pvm_inquiry_pluva_product',
  pvm_inquiry_user_sell_product: 'pvm_inquiry_user_sell_product',
  pvm_visit_pdp: 'pvm_visit_pdp',
  pvm_visit_odp: 'pvm_visit_odp',
};
